<template>
<div class="chapter">
<div class="inner_page">
<p class="ch-image"><img alt="image" src="images/ch.jpg"/></p>
<h2 class="ch-title">Table of Contents</h2>
<p class="toc-chap"><a href="#/xhtml/chap01"><span class="toc-no">Chapter 1:</span> How Did I Get Here</a></p>
<p class="toc-chap"><span href="#/xhtml/chap02" title="Link target outside of Sample"><span class="toc-no">Chapter 2:</span> Where I Discovered My Truth</span></p>
<p class="toc-chap"><span href="#/xhtml/chap03" title="Link target outside of Sample"><span class="toc-no">Chapter 3:</span> How to Go from Broken to Beautiful—My Nine Secrets Unveiled in A Step by Step Process</span></p>
<p class="toc-chap"><span href="#/xhtml/chap04" title="Link target outside of Sample"><span class="toc-no">Chapter 4:</span> Build Your Dream</span></p>
<p class="toc-chap"><span href="#/xhtml/chap05" title="Link target outside of Sample"><span class="toc-no">Chapter 5:</span> Experiences Do Affect You</span></p>
<p class="toc-chap"><span href="#/xhtml/chap06" title="Link target outside of Sample"><span class="toc-no">Chapter 6:</span> Ask for What You Want</span></p>
<p class="toc-chap"><span href="#/xhtml/chap07" title="Link target outside of Sample"><span class="toc-no">Chapter 7:</span> Understanding Your Limiting Beliefs</span></p>
<p class="toc-chap"><span href="#/xhtml/chap08" title="Link target outside of Sample"><span class="toc-no">Chapter 8:</span> Take Control of Your Own Happiness</span></p>
<p class="toc-chap"><span href="#/xhtml/chap09" title="Link target outside of Sample"><span class="toc-no">Chapter 9:</span> I Have to Love Myself?</span></p>
<p class="toc-chap"><span href="#/xhtml/chap10" title="Link target outside of Sample"><span class="toc-no">Chapter 10:</span> Forgiveness Is A Necessity</span></p>
<p class="toc-chap"><span href="#/xhtml/chap11" title="Link target outside of Sample"><span class="toc-no">Chapter 11:</span> Unanswered Prayers</span></p>
<p class="toc-chap"><span href="#/xhtml/chap12" title="Link target outside of Sample"><span class="toc-no">Chapter 12:</span> Letting Go of Fear</span></p>
<p class="toc-chap"><span href="#/xhtml/chap13" title="Link target outside of Sample"><span class="toc-no">Chapter 13:</span> Don’t Let the Roadblocks Stop You</span></p>
<p class="toc-chap"><span href="#/xhtml/chap14" title="Link target outside of Sample"><span class="toc-no">Chapter 14:</span> Bursting into Beautiful</span></p>
<p class="toc-bm"><span href="#/xhtml/bm01" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc-bm"><span href="#/xhtml/bm02" title="Link target outside of Sample">Thank You</span></p>
<p class="toc-bm"><span href="#/xhtml/bm03" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?99c989cc